import { MDBBtn, MDBModalFooter } from 'mdb-react-ui-kit'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { moveUsersLoc } from '../../../apiclients/streamsapi_bridge';
import { useNavigate } from 'react-router';

function UserMoveLoc(props) {
    const { t, i18n } = useTranslation();
    const [locationid, setLocationId] = useState(0);
    const [error, setError] = useState("");
    const navigate = useNavigate();
    console.log("agent :::::::::::::::: "+props.agentList);

    const handleSubmit = async (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (validateField) {
            
            const agents = props.agentList +""?.split(",").map(item => item.trim());
            //alert(agents)
            let update = {
                reqid: 58,
                move_users: props.agentList,
                siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
                location_id: locationid
            }
            //alert(JSON.stringify(update));

            console.log("request for move user ::::::::: "+JSON.stringify(update));

            let response = await moveUsersLoc(update);
            console.log("response before::::: " + JSON.stringify(response));
            let resdata = await response.json();
            console.log("response ::::: " + JSON.stringify(resdata));
            if (response.status === 200) {
                localStorage.setItem("s_message", resdata.message); // success pop up message.

                navigate("/locDetails", {
                    state: {info: props.locDetailsInfo,
                    tab: "tab2",}
                  });
                  window.location.reload();
                props.setRerender(true);
                props.onClose();

            } else {

            }


        }
    }

    const validateField = () => {
        if (locationid === 0) {
            setError("Please select a location");
            return false;
        }
        return true;
    }
    return (
        <>
            <div className="w-100 d-flex  align-items-center justify-content-center">
                <div className="w-100">
                    <strong className=" d-block">
                        {t("location")}
                    </strong>
                    <select
                        className="form-select form-control w-100"
                        name="San Jose"
                        value={locationid}
                        onChange={(e) => {
                            setLocationId(parseInt(e.target.value));
                            if (e.target.value !== 0) {
                                setError("");
                            }
                        }}
                    >
                        <option value={0}>-- Select Location --</option>
                        {props.locationList && props.locationList.length > 0 && props.locationList.map((loc) => (
                            <option value={loc.loc_id}>{loc.loc_name}</option>
                        ))}

                    </select>
                    {error && <div style={{ color: 'red' }}>{error}</div>}
                </div>
            </div>

            <MDBModalFooter>
                <MDBBtn color="secondary" onClick={(e) => props.onClose(e)}>
                    {t("close")}
                </MDBBtn>
                <MDBBtn onClick={handleSubmit}>{t("Move")}</MDBBtn>
            </MDBModalFooter>

        </>
    )
}

export default UserMoveLoc
